import { useEffect } from "react";
import "./App.css";
import "./plugins/i18n";
import RouterRender from "./router/index";
import FontSetting from "./styles/FontSetting";

function App() {
  const defaultTheme = require(`./theme/defaultTheme.json`);
  const finalTheme = { ...defaultTheme };

  const setTheme = () => {
    const r: any = document.querySelector(":root");
    const final = Object.entries(finalTheme);
    final.map((color) => {
      r?.style?.setProperty(color[0], color[1]);
    });
  };
  const initStyle = () => {
    let _vh = window.innerHeight * 0.01;
    window.document.documentElement.style.setProperty("--vh", `${_vh}px`);
  };

  useEffect(() => {
    initStyle();
    setTheme();
  }, []);

  /**
   * SCROLL TESTING PURPOSE
   * DO NOT DELETE, OPEN WHEN DEBUG SCROLL ISSUE ONLY
   */
  // function isScrollable(el: any) {
  //   return el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
  // }
  // window.addEventListener(
  //   "scroll",
  //   function (e: any) {
  //     var el: any = e.target;
  //     while (el && el !== document && !isScrollable(el)) {
  //       el = el?.parent;
  //     }
  //     console.debug("Scrolled element: " + (el?.className || "document"));
  //   },
  //   true
  // );

  return (
    <div>
      <FontSetting />
      <RouterRender />
    </div>
  );
}

export default App;
